import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidesDetailsTable.vue?vue&type=template&id=3a2d98ee&"
import script from "./GrantsConstraintsPlansSlidesDetailsTable.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidesDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports